define(function (require) {
    "use strict";
    var _ = require("underscore");
    var LE = require("app");
    var RevisionedModel = require("models/RevisionedModel");
    var ApiResources = require("assets/data/apiResources.json");

    var URL_PARAMETERS = "&select=$all";
    var KEYS = {
        IDS: "ids"
    };

    var ProfileAssignedToLPAModel = {};

    function moduleDefinition(LEPersonalization, LE, Backbone, Marionette, $, _) {
        ProfileAssignedToLPAModel = RevisionedModel.extend({
            resource: ApiResources.AccountConfig.Profiles,
            defaults: {
                id: "updateIsAssignedToLPA",
                ids: []
            },
            name: "ProfileAssignedToLPAModel",
            url: function(){ //we need to override backbone to not include '/' and the temp id we give to the model before deleting
                var url = RevisionedModel.prototype.url.apply(this, arguments);
                url = url + URL_PARAMETERS;
                return url;
            },

            toJSON:function(options) {
                //we overwrite the toJSON method in order to have in the body only the "ids" field (without the "id")
                var json = RevisionedModel.prototype.toJSON.apply(this, [].slice.apply(arguments));
                delete json.id;
                return json;
            },

            initialize: function (attributes, options) {
                RevisionedModel.prototype.initialize.call(this, options);
            }

        });
    }

    LE.module("LEPersonalization", moduleDefinition);
    return ProfileAssignedToLPAModel;
});
